<i18n>
{
    cn: {
        shopSearchPl: '在此处输入您的搜索内容',
    },
    en: {
        shopSearchPl: 'Type your search here',
    }
}
</i18n>
<script>
import { mapState } from 'vuex';

export default {
    name: "shop",
    data() {
        return {
            isShowNav: false,
            activeIndex: null,
            isShowSearch: false,
            keyword: '',
            searchMenu: [],
            searchGoods: [],
            searchTime: null,
        };
    },
    computed: {
        ...mapState(['shopMenu']),
        // searchMenu() {
        //     if (this.keyword != '') { 
        //         // 获取一级name和三级name含有搜索关键字的一级数组
        //         return this.shopMenu.filter(v => {
        //             if (v.name.indexOf(this.keyword) != -1) { 
        //                 return true;
        //             }
        //             if (v.children.filter(item => item.children.filter(_item => _item.name.indexOf(this.keyword) != -1).length > 0).length > 0) { 
        //                 return true;
        //             }
        //         }).map(v => {
        //             // 处理一级数组，使三级数组也只含有具有关键字的
        //             let children = v.children.filter(item => item.children.filter(_item => _item.name.indexOf(this.keyword) != -1).length > 0).map(item => {
        //                 return {
        //                     ...item,
        //                     children: item.children.filter(_item => _item.name.indexOf(this.keyword) != -1)
        //                 }
        //             })
        //             return {
        //                 ...v,
        //                 children
        //             };
        //         })
        //     } else {
        //         return []
        //     }
        // },
    },
    components: {
        
    },
    mounted() {
        // 菜单
        this.$store.dispatch('getShopMenu');
    },
    destroyed() {},
    watch: {
        '$route': {
            handler: function () { 
                this.isShowNav = false;
                this.isShowSearch = false;
                this.keyword = '';
                this.searchGoods = [];
                this.searchMenu = [];
            }
        }
    },
    methods: {
        tapNav(index) { 
            if (this.activeIndex != index) { 
                this.activeIndex = index;
            } else {
                this.activeIndex = null;
            }
        },
        getSearchMenu() { 
            return this.shopMenu.filter(v => {
                if (v.name.indexOf(this.keyword) != -1) { 
                    return true;
                }
                if (v.children.filter(item => item.children.filter(_item => _item.name.indexOf(this.keyword) != -1).length > 0).length > 0) { 
                    return true;
                }
            }).map(v => {
                // 处理一级数组，使三级数组也只含有具有关键字的
                let children = v.children.filter(item => item.children.filter(_item => _item.name.indexOf(this.keyword) != -1).length > 0).map(item => {
                    return {
                        ...item,
                        children: item.children.filter(_item => _item.name.indexOf(this.keyword) != -1)
                    }
                })
                return {
                    ...v,
                    children
                };
            })
        },
        getData() { 
            this.$showLoading();
            this.$store.dispatch('getShopFilter', {
                category_id: '',
                ids: '',
                page: 1,
                limit: 9999,
                keyword: this.keyword,
                sort: 1,
            }).then((result) => {
                this.$hideLoading();
                if (result.code == 100) { 
                    this.searchGoods = result.data.goods.list;
                    this.searchMenu = this.getSearchMenu();
                }
            }).catch((err) => {
                this.$hideLoading();
            });
        },
        changeKeyword() { 
            if (this.searchTime) clearTimeout(this.searchTime);
            this.searchTime = setTimeout(() => {
                if (this.keyword != '') { 
                    this.getData();
                } else {
                    this.searchGoods = [];
                    this.searchMenu = [];
                }
            }, 500);
        },
        showSearchMobile() { 
            this.isShowSearch = true;
            this.$nextTick(() => {
                this.$refs.search.focus();
            })
        },
    },
};
</script>

<template>
    <div class="shop">
        <!-- 移动端菜单按钮 -->
        <div class="nav_switch only_mobile" :class="{active: isShowNav}" @click="isShowNav = !isShowNav">
            <span></span><span></span><span></span>
        </div>
        <div class="wrapper flex justify_between align_center" :class="{show: isShowNav}">
            <!-- logo -->
            <router-link class="logo only_pc" to="/shop"></router-link>
            <!-- 移动端搜索框 -->
            <div class="search_mobile only_mobile">
                <div class="search_input flex align_center" @click="showSearchMobile">
                    <img src="@/assets/images/icon_shop_popup_search.png" alt="" class="icon"/>
                    <p class="placeholder">{{ $t('shopSearchPl') }}</p>
                    <!-- <input type="text" v-model="keyword" name="" id="" :placeholder="$t('shopSearchPl')" @keyup="changeKeyword"/> -->
                </div>
            </div>
            <!-- 菜单 -->
            <div class="menu flex justify_end">
                <div class="list flex">
                    <div class="item" :class="{active: activeIndex == index}" v-for="(item, index) in shopMenu" :key="index">
                        <div class="name">
                            <!-- 有二级页面 -->
                            <router-link v-if="item.info_type == 1" :to="`/shop/category/${item.id}`">{{ item.name }}</router-link>
                            <!-- 没有二级页面，直接去筛选 -->
                            <router-link v-else :to="`/shop/category/${item.id}/filter`">{{ item.name }}</router-link>
                            <div class="arrow only_mobile" v-if="item.children.length > 0" @click="tapNav(index)"></div>
                        </div>
                        <div class="popup" v-if="item.children.length > 0 || (item.recommend.name && item.recommend.image && item.recommend.link)">
                            <div class="layout_main">
                                <div class="flex justify_between">
                                    <!--  -->
                                    <div class="category_group flex">
                                        <div class="category" v-for="(_item, _index) in item.children" :key="_index">
                                            <p class="name">{{ _item.name }}</p>
                                            <div class="list flex flex_column">
                                                <p class="item" v-for="(__item, __index) in _item.children" :key="__index">
                                                    <router-link :to="`/shop/category/${item.id}/filter?id=${__item.id}`">{{ __item.name }}</router-link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!--  -->
                                    <div class="product" v-if="item.recommend.name && item.recommend.image && item.recommend.link" :class="{big: item.children.length <= 1}">
                                        <div class="layout_bg bg" :style="`background-image: url(${item.recommend.image});`"></div>
                                        <div class="name">{{ item.recommend.name }}</div>
                                        <a class="link" :href="item.recommend.link">立即购买</a>
                                    </div>
                                </div>
                                <p class="btn_filter"><router-link :to="`/shop/category/${item.id}/filter`">全部筛选</router-link></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="icons flex align_center only_pc">
                    <!-- <router-link class="item" to="">
                        <img src="@/assets/images/icon_shop_user.png" alt="" class="icon"/>
                    </router-link> -->
                    <div class="item" v-if="isShowSearch" @click="isShowSearch = false">
                        <img src="@/assets/images/icon_shop_search_close.png" alt="" class="icon"/>
                    </div>
                    <div class="item" v-else @click="isShowSearch = true">
                        <img src="@/assets/images/icon_shop_search.png" alt="" class="icon"/>
                    </div>
                    <router-link class="item" to="/shopping">
                        <img src="@/assets/images/icon_shop_bag.png" alt="" class="icon"/>
                    </router-link>
                </div>
            </div>
        </div>
        <!-- 搜索 -->
        <div class="search" :class="{has_keyword: keyword != '', show: isShowSearch}">
            <div class="btn_close only_mobile" @click="isShowSearch = false"><span></span><span></span></div>
            <!-- 输入框 -->
            <div class="input_wrap">
                <div class="search_input flex align_center">
                    <img src="@/assets/images/icon_shop_popup_search.png" alt="" class="icon"/>
                    <input type="text" ref="search" v-model="keyword" name="" id="" :placeholder="$t('shopSearchPl')" @keyup="changeKeyword"/>
                </div>
            </div>
            <!-- 结果 -->
            <div class="result">
                <div class="layout_main flex">
                    <!-- 分类 -->
                    <div class="category_wrap">
                        <template v-if="searchMenu.length > 0">
                            <p class="title">分类</p>
                            <div class="category flex flex_column">
                                <div class="item" v-for="(item, index) in searchMenu" :key="index">
                                    <p class="name">
                                        <!-- 有二级页面 -->
                                        <router-link v-if="item.info_type == 1" :to="`/shop/category/${item.id}`">{{ item.name }}</router-link>
                                        <!-- 没有二级页面，直接去筛选 -->
                                        <router-link v-else :to="`/shop/category/${item.id}/filter`">{{ item.name }}</router-link>
                                    </p>
                                    <div class="list flex flex_column" v-if="item.children.length > 0">
                                        <div class="item" v-for="(_item, _index) in item.children" :key="_index">
                                            <!-- <p class="name">{{ _item.name }}</p> -->
                                            <div class="list flex flex_column">
                                                <p class="item" v-for="(__item, __index) in _item.children" :key="__index">
                                                    <router-link :to="`/shop/category/${item.id}/filter?id=${__item.id}`">{{ __item.name }}</router-link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <!-- 商品 -->
                    <div class="goods">
                        <template v-if="searchGoods.length > 0">
                            <div class="title">商品</div>
                            <div class="list flex flex_wrap">
                                <router-link class="item flex" v-for="(item, index) in searchGoods" :key="index" :to="`/shop/detail?id=${item.id}`">
                                    <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                                    <div class="content">
                                        <p class="name">{{ item.name }}</p>
                                        <p class="price">RMB {{ item.price }}</p>
                                    </div>
                                </router-link>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<style scoped lang="scss">
.shop{
    position: relative;
}
.search_mobile{
    width: 100%;
    padding: 0 .3rem;
    @media only screen and (max-width: 750px) {
        padding: 1rem .3rem .5rem;
    }
}
.search_input{
    width: 5rem;
    margin: 0 auto;
    border-bottom: 1px solid #999;
    padding: .1rem 0;
    @media only screen and (max-width: 750px) {
        width: 100%;
    }
    .icon{
        width: .46rem;
        margin-right: .2rem;
    }
    .placeholder,
    input{
        width: 0;
        flex: 1;
        font-size: .38rem;
        height: .42rem;
        line-height: .42rem;
        &::placeholder{
            color: #999;
        }
        @media only screen and (max-width: 750px) {
            font-size: .3rem;
            height: .34rem;
            line-height: .34rem;
        }
    }
    .placeholder{
        color: #999;
    }
}
.search{
    position: absolute;
    top: .9rem;
    left: 0;
    width: 100%;
    min-height: calc(100vh - .9rem);
    background: #fff;
    z-index: 10;
    transform: translate(0, -100%);
    opacity: 0;
    visibility: hidden;
    transition: transform .3s, opacity .3s, visibility .3s;
    .btn_close{
        width: .6rem;
        height: .6rem;
        border-radius: 50%;
        border: 1px solid #333;
        position: fixed;
        top: .3rem;
        right: .3rem;
        z-index: 1;
        background: #fff;
        span{
            width: 50%;
            height: .04rem;
            background: #333;
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            &:nth-of-type(1){
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &:nth-of-type(2){
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
    }
    @media only screen and (max-width: 750px) {
        z-index: 12;
        transform: translate(0, 0);
        transition: none;
        position: fixed;
        top: 1.6rem;
        height: calc(100% - 1.6rem);
        min-height: auto;
        display: block;
        overflow: hidden;
        overflow-y: auto;
    }
    &.has_keyword{
        background: #f8f8f8;
    }
    &.show{
        transform: translate(0, 0);
        opacity: 1;
        visibility: visible;
    }
    .input_wrap{
        padding: 1.2rem 0 .5rem;
        background: #fff;
        @media only screen and (max-width: 750px) {
            padding: 1rem .3rem .5rem;
        }
    }
    .result{
        padding: .5rem 0;
        @media only screen and (max-width: 750px) {
            padding: .5rem .3rem;
            .layout_main{
                display: block;
            }
        }
        .title{
            font-size: .28rem;
            margin-bottom: .2rem;
            @media only screen and (max-width: 750px) {
                font-size: .34rem;
            }
        }
        .category_wrap{
            width: 4rem;
            @media only screen and (max-width: 750px) {
                width: 100%;
            }
        }
        .category{
            gap: .1rem;
            @media only screen and (max-width: 750px) {
                gap: .3rem;
                margin-bottom: .5rem;
            }
            >.item{
                >.name{
                    font-size: .22rem;
                    // margin-bottom: .1rem;
                    @media only screen and (max-width: 750px) {
                        font-size: .28rem;
                    }
                }
                >.list{
                    gap: .1rem;
                    padding-top: .1rem;
                    >.item{
                        // >.name{
                        //     font-size: .2rem;
                        //     margin-bottom: .1rem;
                        // }
                        >.list{
                            gap: .1rem;
                            .item{
                                font-size: .2rem;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                @media only screen and (max-width: 750px) {
                                    font-size: .26rem;
                                }
                            }
                        }
                    }
                }
            }
            .list{
                padding-left: .15rem;
            }
            a{
                display: flex;
                align-items: center;
                line-height: 1.4;
                &::after{
                    content: "";
                    width: .1rem;
                    height: .1rem;
                    border-top: 1px solid #333;
                    border-right: 1px solid #333;
                    transform: rotate(45deg);
                }
                &:hover{
                    text-decoration: underline;
                    @media only screen and (max-width: 750px) {
                        text-decoration: none;
                    }
                }
            }
        }
        .goods{
            flex: 1;
            .list{
                gap: .2rem;
                .item{
                    width: calc(50% - .1rem);
                    font-size: .18rem;
                    .cover{
                        width: 1.6rem;
                        height: 1.6rem;
                        margin-right: .2rem;
                    }
                    .content{
                        padding: .1rem 0;
                        line-height: 1.6;
                    }
                    &:hover{
                        .name{
                            text-decoration: underline;
                            @media only screen and (max-width: 750px) {
                                text-decoration: none;
                            }
                        }
                    }
                    @media only screen and (max-width: 750px) {
                        width: 100%;
                        font-size: .26rem;
                        .cover{
                            width: 2.3rem;
                            height: 2.3rem;
                            margin-right: .3rem;
                        }
                        .content{
                            padding: .2rem 0;
                        }
                    }
                }
            }
        }
    }
}
.nav_switch{
    @media only screen and (max-width: 750px) {
        width: .6rem;
        height: .6rem;
        border-radius: 50%;
        border: 1px solid #333;
        position: fixed;
        top: 1.9rem;
        right: .3rem;
        z-index: 12;
        background: #fff;
        span{
            width: 50%;
            height: .04rem;
            background: #333;
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            &:nth-of-type(1){
                transform: translate(-50%, -250%);
            }
            &:nth-of-type(3){
                transform: translate(-50%, 150%);
            }
            transition: all .3s;
        }
        &.active{
            span{
                &:nth-of-type(1){
                    transform: translate(-50%, -50%) rotate(45deg);
                }
                &:nth-of-type(3){
                    transform: translate(-50%, -50%) rotate(-45deg);
                }
                &:nth-of-type(2){
                    opacity: 0;
                }
            }
        }
    }
}
.wrapper{
    height: .9rem;
    background: #fff;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 11;
    box-shadow: 0 0 .1rem rgba($color: #000000, $alpha: .2);
    padding: 0 2.1rem 0 1rem;
    @media only screen and (max-width: 750px) {
        // display: none;
        position: fixed;
        top: 1.6rem;
        left: 0;
        // bottom: 0;
        width: 100%;
        height: calc(100% - 1.6rem);
        padding: 0;
        display: block;
        // justify-content: start;
        // flex-direction: column;
        // align-items: flex-end;
        // z-index: 10;
        opacity: 0;
        transform: translate(100%, 0);
        transition: all .3s;
        overflow: hidden;
        overflow-y: auto;
        &.show{
            opacity: 1;
            transform: translate(0, 0);
        }
    }
    .logo{
        width: 2.56rem;
        height: .43rem;
        background: url('~@/assets/images/logo_shop.png') no-repeat 0/100%;
    }
}
.menu{
    height: 100%;
    gap: .4rem;
    @media only screen and (max-width: 750px) {
        padding: .6rem 0;
        height: auto;
        width: 100%;
        justify-content: flex-start;
    }
    .icons{
        gap: .15rem;
        .item{
            cursor: pointer;
        }
    }
    >.list{
        // padding-right: .25rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
            flex-direction: column;
        }
        >.item{
            &:hover{
                >.name{
                    background: #f8f8f8;
                    @media only screen and (max-width: 750px) {
                        background: none;
                    }
                }
                .popup{
                    display: block;
                    @media only screen and (max-width: 750px) {
                        display: none;
                    }
                }
            }
            @media only screen and (max-width: 750px) {
                &.active{
                    >.name{
                        .arrow{
                            &::after{
                                transform: translate(-50%, -50%) rotate(135deg);
                            }
                        }
                    }
                    .popup{
                        display: block;
                    }
                }
            }
            >.name{
                display: block;
                line-height: .9rem;
                font-size: .18rem;
                color: #666;
                cursor: pointer;
                @media only screen and (max-width: 750px) {
                    color: #333;
                }
                a{
                    display: block;
                    padding: 0 .15rem;
                    position: relative;
                    &::after{
                        content: "";
                        display: block;
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        border-bottom: 2px solid #333;
                        display: none;
                        @media only screen and (max-width: 750px) {
                            width: auto;
                            left: .3rem;
                            right: .3rem;
                            bottom: .2rem;
                            border-bottom: 1px solid #333;
                        }
                    }
                    &.active{
                        &::after{
                            display: block;
                        }
                        @media only screen and (max-width: 750px) {
                            font-weight: bold;
                        }
                    }
                }
                @media only screen and (max-width: 750px) {
                    font-size: .32rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    a{
                        display: inline-block;
                        padding: 0 .3rem;
                    }
                    .arrow{
                        position: relative;
                        width: .9rem;
                        height: .9rem;
                        &::after{
                            content: "";
                            display: block;
                            width: .16rem;
                            height: .16rem;
                            border-top: 1px solid #666;
                            border-right: 1px solid #666;
                            transform: translate(-50%, -50%) rotate(45deg);
                            position: absolute;
                            top: 50%;
                            left: 50%;
                        }
                    }
                }
            }
            .popup{
                position: absolute;
                top: 100%;
                left: 0;
                padding: .5rem 0;
                background: #f8f8f8;
                width: 100%;
                display: none;
                @media only screen and (max-width: 750px) {
                    position: relative;
                    top: 0;
                    padding: .4rem 0;
                }
                .btn_filter{
                    font-size: .18rem;
                    margin-top: .5rem;
                    @media only screen and (max-width: 750px) {
                        font-size: .3rem;
                        padding: 0 .3rem;
                        margin-top: .4rem;
                    }
                    a{
                        &:hover{
                            border-bottom: 1px solid #666;
                        }
                    }
                }
                .category_group{
                    flex: 1;
                    .category{
                        flex: 1;
                        line-height: 1;
                        .name{
                            font-size: .25rem;
                            margin-bottom: .2rem;
                        }
                        .list{
                            font-size: .18rem;
                            gap: .2rem;
                            .item{
                                a{
                                    &:hover{
                                        border-bottom: 1px solid #666;
                                    }
                                }
                            }
                        }
                    }
                    @media only screen and (max-width: 750px) {
                        flex-direction: column;
                        padding: 0 .3rem;
                        gap: .3rem;
                        .category{
                            .name{
                                font-size: .3rem;
                                margin-bottom: .3rem;
                            }
                            .list{
                                padding: 0 .3rem;
                                font-size: .28rem;
                                gap: .3rem;
                            }
                        }
                    }
                }
                .product{
                    flex-shrink: 0;
                    width: 3rem;
                    text-align: center;
                    @media only screen and (max-width: 750px) {
                        display: none;
                    }
                    &.big{
                        width: 4rem;
                    }
                    .bg{
                        height: 0;
                        padding-bottom: 100%;
                        margin-bottom: .3rem;
                        // 
                        // border: 1px solid #000;
                    }
                    .name{
                        font-size: .2rem;
                        font-weight: bold;
                        margin-bottom: .1rem;
                    }
                    .link{
                        font-size: .18rem;
                    }
                }
            }
        }
    }
}
</style>